function ModuleListController() {
  const ctrl = this;

  ctrl.$onInit = () => {};

  ctrl.$onChanges = () => {
    if (ctrl.selection?.modules) {
      if (!ctrl.selectedCar || ctrl.selectedCar !== ctrl.selection.id) {
       // Initialize the array to hold the expand status of the accordion ui
        ctrl.customAccordionStatus = Array(ctrl.selection.modules.length).fill(true);
        ctrl.selectedCar = ctrl.selection.id; 
      }
    }
  };

  ctrl.selectModule = event => {
    ctrl.activeModule = event.module;
    ctrl.onSelect({
      $event: event.module,
    });
  };

  ctrl.groupSelected = function(index) {
    ctrl.customAccordionStatus[index] = !ctrl.customAccordionStatus[index];
  } 
}

angular
  .module('configuration-management.module')
  .controller('ModuleListController', ModuleListController);
